<template>
<div>
  <div class="wistia_embed wistia_async_q5kdy8q9tv">
    &nbsp;
  </div>

  <div
    id="vid-embeds-one"
    class="tbk-vid-embed"
  >
    <a
      id="burger-one"
      class="embedded_video"
      href="#wistia_w82vmcu11w?videoFoam=true"
    >
      &nbsp;
    </a>
  </div>

  <div
    id="vid-embeds-two"
    class="tbk-vid-embed"
  >
    <a
      id="burger-two"
      class="embedded_video"
      href="#wistia_yuy8cbfr6l?videoFoam=true"
    >
      &nbsp;
    </a>
  </div>

  <div
    id="vid-embeds-three"
    class="tbk-vid-embed"
  >
    <a
      id="burger-three"
      class="embedded_video"
      href="#wistia_zl9cn2o77k?videoFoam=true"
    >
      &nbsp;
    </a>
  </div>

  <div
    id="vid-embeds-final"
    class="tbk-vid-embed"
  >
    &nbsp;
  </div>
</div>
</template>

<script>
import TbkVideoMixin from './TbkVideoMixin'

export default {
  mixins: [TbkVideoMixin],

  mounted() {
    _wq.push({
      q5k: this.showSelectOne,
      w82: this.showSelectTwo,
      yuy: this.showSelectThree,
      zl9: this.showFinal
    })
  },

  methods: {
    showSelect(video) {
      const that = this
      video.bind('end', function() {
        if (this.hashedId() !== 'qztw06ghy1') {
          $('#vid-question').text('Try a different response.')
        }

        $('.tbk-vid-embed').show()
        that.tbk.hideMobileControls()
      })
    },

    showSelectOne(video) {
      const that = this
      video.bind('end', function() {
        $('#vid-embeds-one').show()
        that.tbk.hideMobileControls()
      })
    },

    showSelectTwo(video) {
      const that = this
      this.tbk.autoPlay(video)
      video.bind('end', function() {
        $('#vid-embeds-two').show()
        that.tbk.hideMobileControls()
      })
    },

    showSelectThree(video) {
      const that = this
      this.tbk.autoPlay(video)
      video.bind('end', function() {
        $('#vid-embeds-three').show()
        that.tbk.hideMobileControls()
      })
    },

    showSelectFinal(video) {
      const that = this
      this.tbk.autoPlay(video)
      video.bind('end', function() {
        $('#vid-embeds-final').show()
        that.tbk.hideMobileControls()
      })
    }
  }
}
</script>

<style scoped lang="sass">
.tbk-vid-embed
  display: none
  font-family: "azo-sans-web", sans-serif
#burger-one
  position: absolute
  z-index: 21
  top: calc(100% * (90 / 360))
  left: calc(100% * (60 / 640))
  width: calc(100% * (170 / 640))
  height: calc(100% * (225 / 360))
#burger-two
  position: absolute
  z-index: 21
  top: calc(100% * (90 / 360))
  left: calc(100% * (250 / 640))
  width: calc(100% * (170 / 640))
  height: calc(100% * (225 / 360))
#burger-three
  position: absolute
  z-index: 21
  top: calc(100% * (90 / 360))
  left: calc(100% * (430 / 640))
  width: calc(100% * (170 / 640))
  height: calc(100% * (225 / 360))

@media (max-width: 450px)
  #vid-embeds-one
    background-image: url('~./dr_you_6_1-burger1.jpg')
  #vid-embeds-two
    background-image: url('~./dr_you_6_1-burger2.jpg')
  #vid-embeds-three
    background-image: url('~./dr_you_6_1-burger3.jpg')
  #vid-embeds-final
    background-image: url('~./dr_you_6_1-final.jpg')
</style>
